import { FetchError } from 'api/API';
import { A01 } from 'api/U007';
import { useCallback, useContext, useState } from 'react';
import { AppContext } from 'templates/AppContextProvider';

export interface ForgetPassword {
  status: string;
  msg: string;
}

type ForgetPasswordDoRequest = (param: {
  request: { username: string };
  onSuccess?: (response: ForgetPassword) => void;
  onError?: (err: Error) => void;
  cancellation?: AbortSignal;
}) => Promise<void>;

export function useForgetPassword(): [ForgetPasswordDoRequest, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const ctx = useContext(AppContext);

  const FetchForgetPassword = async (username: string, cancellation: AbortSignal) => {
    const json = await A01(username, ctx.currentLang, cancellation);
    return json;
  };

  const doRequest: ForgetPasswordDoRequest = useCallback(
    async ({ request, cancellation, onSuccess, onError }) => {
      const controller = new AbortController();
      const cancelSignal = cancellation ?? controller.signal;
      setLoading(true);
      setError(null);
      try {
        const result = await FetchForgetPassword(request.username, cancelSignal);
        onSuccess?.(result);
      } catch (err) {
        console.error({ err });
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.msg || `HTTP ERROR: ${err.message}`);
          onError?.(flooredError);
          setError(flooredError);
        } else {
          const flooredError = new Error(`unknown error. ${err}`);
          onError?.(flooredError);
          setError(flooredError);
        }
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return [doRequest, loading, error];
}
